define("powergen/components/x-improvement-answer-overlay",
  [],
  function() {
    "use strict";
    var XImprovementAnswerOverlayComponent;

    XImprovementAnswerOverlayComponent = Ember.Component.extend({
      tagName: 'div',
      classNames: ['overlay', 'improvement-answer-overlay'],
      classNameBindings: ['improvement.part.type.id', 'show', 'showArrow::no-arrow'],
      attributeBindings: ['style'],
      actions: {
        close: function() {
          return this.set('show', false);
        }
      },
      style: (function() {
        var containerHeight, containerWidth, left, top;
        this.set('showArrow', true);
        containerHeight = this.get('containerHeight');
        containerWidth = this.get('containerWidth');
        left = this.get('improvement.position.x') + (this.get('improvement.size.width') / 2) - 56;
        if (left + this.get('width') > containerWidth) {
          left = Math.abs(containerWidth - this.get('width'));
          this.set('showArrow', false);
        }
        top = this.get('improvement.position.y') + this.get('improvement.size.height');
        if (top + this.get('height') > containerHeight) {
          top = Math.abs(containerHeight - this.get('height'));
          this.set('showArrow', false);
        }
        return this.get('util').styleString({
          'width': '%@px'.fmt(this.get('width')),
          'left': '%@px'.fmt(left),
          'top': '%@px'.fmt(top)
        });
      }).property('improvement.id', 'containerWidth', 'containerHeight', 'height', 'showArrow'),
      showWillChange: (function() {
        var improvement;
        if (this.get('show')) {
          improvement = this.get('improvement');
          improvement.setProperties({
            'isCorrected': improvement.get('isCorrect') && !improvement.get('isCorrected') ? false : true,
            'selectedPart': improvement.get('part')
          });
        }
        return this.set('height', this.$().height());
      }).observesBefore('show', 'improvement.id'),
      show: false,
      width: 350,
      containerWidth: 0,
      containerHeight: 0,
      height: 0,
      showArrow: true,
      didInsertElement: function() {
        this.set('containerWidth', $('.improvements').first().width());
        this.set('containerHeight', $('.improvements').first().height());
        return this.set('height', this.$().height());
      }
    });


    return XImprovementAnswerOverlayComponent;
  });